import { createReducer, on } from '@ngrx/store';
import { produce } from 'immer';
import { PaymentTypeOptions } from 'src/app/models/payments.model';
import {
  setClient,
  setClientAddress,
  setContractAccounts,
  setDebtsInfo,
  setGroupedInvoices,
  setInvoices,
  setMaxInstallments,
  setOrder,
  setOrderId,
  setPaymentModule,
  setPaymentStatus,
  setPaymentType,
  setRegistrationDebts,
  setRepresentativeRegistrationDebts,
  setSelectedInvoices,
} from './payment.actions';
import { paymentIntialState } from './payment.types';
import { Invoices } from 'src/app/models/invoice.model';

export const paymentReducer = createReducer(
  paymentIntialState,
  on(setPaymentModule, (state, payment) =>
    produce(state, (draft) => {
      draft.paymentModule = payment.paymentModule;
    })
  ),

  on(setOrder, (state, { order }) =>
    produce(state, (draft) => {
      draft.order.debtsInfo = order.debtsInfo;
      draft.order.paymentConditionsInfo = order.paymentConditionsInfo || null;
    })
  ),

  on(setOrderId, (state, payment) =>
    produce(state, (draft) => {
      draft.orderId = payment.orderId;
    })
  ),

  on(setInvoices, (state, payment) =>
    produce(state, (draft) => {
      draft.invoices = payment.invoices.filter(
        (invoice) => invoice.value !== 0 && !invoice.is_paid
      );
    })
  ),

  on(setSelectedInvoices, (state, payment) =>
    produce(state, (draft) => {
      draft.selectedInvoices = payment.invoices as Invoices[];
    })
  ),

  on(setRegistrationDebts, (state, payment) =>
    produce(state, (draft) => {
      draft.registrationDebts = payment.registrationDebts;
    })
  ),

  on(setRepresentativeRegistrationDebts, (state, payment) =>
    produce(state, (draft) => {
      draft.representativeRegistrationDebts = payment.representativeRegistrationDebts;
    })
  ),

  on(setPaymentType, (state, payment) =>
    produce(state, (draft) => {
      draft.paymentType = payment.paymentType.toLowerCase() as PaymentTypeOptions;
    })
  ),

  on(setPaymentStatus, (state, payment) =>
    produce(state, (draft) => {
      draft.status = payment.status;
    })
  ),

  on(setPaymentStatus, (state, payment) =>
    produce(state, (draft) => {
      draft.status = payment.status;
    })
  ),

  on(setContractAccounts, (state, payment) =>
    produce(state, (draft) => {
      draft.contractAccounts = payment.contractAccounts;
    })
  ),

  on(setGroupedInvoices, (state, payment) =>
    produce(state, (draft) => {
      draft.groupedInvoices = payment.groupedInvoices;
    })
  ),

  on(setDebtsInfo, (state, payment) =>
    produce(state, (draft) => {
      draft.order.debtsInfo = payment.debts;
    })
  ),

  on(setMaxInstallments, (state, payment) =>
    produce(state, (draft) => {
      draft.maxInstallments = payment.maxInstallments;
    })
  ),

  on(setClient, (state, payment) =>
    produce(state, (draft) => {
      const client = { ...payment.client };
      if (!client.address) client.address = draft.client.address;
      draft.client = client;
    })
  ),
  on(setClientAddress, (state, params) =>
    produce(state, (draft) => {
      draft.client = { ...draft.client, address: params.address };
    })
  )
);
